<template>
  <section class="chan-pin-man-yi-du">
    <el-button type="primary" @click="toAdd">新增</el-button>
    <el-button type="primary" @click="getTableData">查询</el-button>
    <el-table :data="tableData" style="width: 100%">
<!--      <el-table-column prop="createBy" label="创建者" width="180"></el-table-column>-->
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="delFlag" label="删除标志"></el-table-column>
      <el-table-column prop="year" label="年份"></el-table-column>
      <el-table-column prop="yearTotalSales" label="年度累计销售额"></el-table-column>
      <el-table-column prop="opt" width="160" label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="editData(scope.row)">编辑</el-button>
          <el-button size="small" @click="deleteData(scope.row)">删除</el-button>
        </template>
      </el-table-column>
<!--      <el-table-column prop="updateBy" label="更新者"></el-table-column>-->
<!--      <el-table-column prop="updateTime" label="更新时间"></el-table-column>-->
    </el-table>
    <el-dialog :title="form.id ? '编辑' :'新增'" :visible.sync="dialogVisible" :width="dialogWidth">
      <div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="年份">
            <el-input :disabled="form.id" v-model="form.year"></el-input>
          </el-form-item>
          <el-form-item label="年度累计销售额">
            <el-input v-model="form.yearTotalSales"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: 'chan-pin-man-yi-du',
  props: {},
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {}
    };
  },
  computed: {
    dialogWidth () {
      return window.screen.width > 768 ? '600px' : '90%'
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    toAdd () {
      this.form = {}
      this.dialogVisible = true
    },
    // 保存新增
    async saveData () {
      let params = {
        ...this.form
      }
      let url = this.form.id ? 'salesData/updateSalesData' : 'salesData/createSalesData'
      let res = await this.$http.post(url, params)
      if (res.data.code === 200) {
        this.$message.warning(this.form.id ? '编辑成功！' : '新增成功！')
        this.dialogVisible = false
        this.getTableData()
      }
    },
    // 获取详情
    async getTableData () {
      let res = await this.$http.get('salesData/getSalesData')
      if (res.data.code === 200) {
        this.tableData = res.data.data
      }
    },
    async editData (row) {
      this.form = row
      this.dialogVisible = true
    },
    // 删除
    async deleteData (row) {
      try {
        await this.$confirm('确认删除该数据？')
        let params = {
          params: { id: row.id }
        }
        let res = await this.$http.delete('salesData/deleteSalesData', params)
        if (res.data.code === 200) {
          this.$message.warning('删除成功！')
          this.getTableData()
        }
      } catch (err) {
        console.error(err)
      }
    }
  },
};
</script>

<style scoped>
.chan-pin-man-yi-du {
}
</style>
